import React from "react";

const XIcon = ({ stroke = "#2D2C44", size = "medium" }) => size === "medium" ?
  (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="x">
      <path id="Icon" d="M15 5.5L5 15.5M5 5.5L15 15.5" stroke={stroke} strokeOpacity="0.7" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  </svg>) : (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="x">
      <path id="Icon" d="M12.5 5.5L5.5 12.5M5.5 5.5L12.5 12.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"
        strokeLinejoin="round"/>
    </g>
  </svg>);

export default XIcon;
